<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <ManagerSidebarMenu v-if="checkIsManager()" :show_menu="false" :show_back_button="true" back_link="managerReports"></ManagerSidebarMenu>
      <ManagerSidebarMenu v-if="checkIsMentor()" :show_menu="false" :show_back_button="true" back_link="mentorReports"></ManagerSidebarMenu>
      
      <div class="content-wrapper" style="padding-left: 165px;">
        <div class="container-wrapper center ml-2">

          <div class="row mt-3 mb-3 border-bottom pb-2">
            <div class="col">
              <div class="h4 text-uppercase">Usage Report</div>
            </div>
            <div class="col">
              <div v-if="results.length > 0" class=""  style="margin-top: 2px;float: right;margin-left: 15px;" @click="shareButtonModal()">
                <img class="" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" />
              </div>

              <div v-if="results.length > 0" style="margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;" @click="exportCSVAction()">
                <img v-if="results.length > 0"  class="" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" style="cursor: pointer;" />
              </div>
            </div>
          </div>

          <div>
            <div class="row report_heading">
              <div class="field_1">No</div>
              <div class="field_2">Account Name</div>
              <div class="field_3">Number of Managers</div>
              <div class="field_4">Number of Mentors</div>
              <div class="field_5">Number of Mentees</div>
              <div class="field_6">Reps to Review</div>
              <div class="field_7">Reps Recorded</div>
              <div class="field_8">Competencies Earned</div>
              <div class="field_9">Inactive Mentees</div>
              <div class="col-12">
                <div class="custom_heading_hr"></div>
              </div>
            </div>

            <div v-show="loading" class="loading_show">
              <div class="spinner-border text-danger"></div>
            </div>

            <div class="row report_view" v-for="(result, rindex) in results" :key="rindex">
              <div class="field_1">{{ parseInt(rindex + 1) }}</div>
              <div class="field_2">{{ result.accountName }}</div>
              <div class="field_3 text-align-center">{{ result.managerCount }}</div>
              <div class="field_4 text-align-center">{{ result.mentorCount }}</div>
              <div class="field_5 text-align-center">{{ result.menteeCount }}</div>
              <div class="field_6 text-align-center">{{ result.repsReviewCount }}</div>
              <div class="field_7 text-align-center">{{ result.repsAddedCount }}</div>
              <div class="field_8 text-align-center">{{ result.competencyEarnedCount }}</div>
              <div class="field_9 text-align-center">{{ result.inactivementeeCount }}</div>
              <div class="col-12">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding" style="color: #68C47E; text-align: center; margin-bottom: 15px;">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255"
                @keyup="checkEmail()" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <!-- <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>Please wait...</b></button>
        </div> -->

        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
            <button :disabled="share_button_disable" v-on:click="shareButtonSubmit()"
                class="btn ma-blue-btn col-3 input-height-25 createBtn"
                style="line-height: 30px; border-radius: 10px;"><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
            <button disabled="true" class="btn ma-blue-btn col-lg-3"
                style="line-height: 30px; border-radius: 10px;"><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>

    <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"></div>
      <div slot="body">
        <div class="">
          <div class="export-details">
            Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
          </div>
          <div class="percentage-text">
            {{ percentage }}
          </div>
          <div class="batch-box">
            <div class="batch-loading" id="batch-loading" >
              &nbsp;
            </div>
          </div>
          <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
            Download CSV File
          </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding"></div>
    </BatchModal>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
// import VeeValidate from 'vee-validate';
import UserMenu from '../shared/user_menu.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import BatchModal from '../admin/reports/report_loading_modal.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';

// Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  components: {
    UserMenu,
    ManagerSidebarMenu,
    MentorSidebarMenu,
    ShareReportModal,
    BatchModal,
  },
  data() {
    return {
      loading: false,
      showOverlay: false,
      results: [],
      apiUrl: '',
      isModalVisible: false,

      submit_text: 'Submit',
      share_email: '',
      showOverlay: false,
      showWait: false,
      showShareSuccess: false,
      isExportModalVisible: false,
      percentage: '0%',
      fileName: '',
      totalCSVPages: 0,
      perCSVPage: 500,
      rowsCSV: 0,
      rowsExportedCSV: 0,
      currentCSVPage: 1,
      share_button_disable: true,
    }
  },
  methods: {
    checkEmail: function () {
      if ((this.verrors.items.length === 0)) {
        this.share_button_disable = false;
      }
      else {
        this.share_button_disable = true;
      }
    },
    checkIsMentor() {
      return checkIsMentor();
    },
    checkIsManager() {
      return checkIsManager();
    },
    fetchUsageListCSV: function() {
      axios('/desktop/v2/manager/usage-report-csv', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(response =>  {
        this.isExportModalVisible = true;
        this.currentCSVPage = response.data.page;
        this.rowsCSV = response.data.total_rows;
        this.rowsExportedCSV = response.data.total_rows_exported;
        this.totalCSVPages = response.data.total_pages;
        this.percentage = response.data.percentage;
        this.fileName = response.data.file_name;
        document.getElementById("batch-loading").style.width = this.percentage;
        if(this.currentCSVPage <= this.totalCSVPages) {
          this.fetchUsageListCSV();
        }

      })
      .catch(function() { });
    },
    fetchIUsersListitems() {
      this.loading = true;

      axios('/desktop/v2/manager/account_usage_report', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(response =>  {
          this.loading = false;
          this.results = response.data.data;
      })
      .catch(function() { });
    },

    shareButtonSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if ((this.verrors.items.length === 0)) {
          this.submit_text = 'Please wait...';
          this.showWait = true;
          this.currentCSVPage = 1;
          this.rowsCSV = 0;
          this.rowsExportedCSV = 0;
          this.totalCSVPages = 0;
          this.percentage = 0;
          this.fileName = '';
          this.showWait = true;

          axios('/desktop/v2/manager/share-usage-report', {
            method: 'POST',
            data: {            
              email: this.share_email,
              account_id: this.$store.state.user_accountid, 
            },
          })
          .then((resp) => {
            this.share_email = '';
            this.submit_text = 'Submit';
            this.share_button_disable = true;
            this.showWait = false;
            this.showShareSuccess = true;
            setTimeout(() => {
                this.showShareSuccess = false;
            }, 5000)
          })
          .catch(() => {});
        }
      });
    },
    shareButtonModal() {
      this.isModalVisible = true;
    },
    downloadFunc: function() {
      var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Usage';
      window.location.href = url;
      this.isExportModalVisible = false;
      return false;
    },
    exportCSVAction: function() {
      this.isExportModalVisible = false;
      this.currentCSVPage = 1;
      this.rowsCSV = 0;
      this.rowsExportedCSV = 0;
      this.totalCSVPages = 0;
      this.percentage = 0;
      this.fileName = '';
      this.fetchUsageListCSV();
    },
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
    this.fetchIUsersListitems();
  }
}
</script>

<style scoped>
.report_heading {   
    font-size: 14px; 
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid #A3A3A3;
}
.field_1 {
  width: 5%;
  padding-left: 15px;
}
.field_3, .field_4, .field_5, .field_6, .field_7, .field_8, .field_9 {
  width: 11%;
  text-align: center;
}
.field_9 {
  padding-right: 15px;
}
.field_2 {
  width: 15%;
}
.field_3 {
  width: 13%;
}
.btn:disabled {
    background-color: #8b8b8b;
    color: #FFF;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/usage_reports.vue